import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

import { getCountryElement } from '@/components/CountryPreview';
import { renderMunicipality, renderProvince } from '@/utils/location';

const FullAddressPreview = ({ value, showCountry, className }) => {
  
  const keys = useMemo(() => {
    const result = [];
    if (value?.country && !isEmpty(value) && showCountry)
      result.push(getCountryElement(value?.country));
    if (value?.province)
      result.push(renderProvince(value?.province));
    if (value?.municipality)
      result.push(renderMunicipality(value?.municipality));
    if (value?.abstract)
      result.push(value?.abstract);
    return result;
  }, [showCountry, value]);
  
  if (!value) return '-';
  
  return (
    <div className={classNames('text-xs', className)}>{keys?.join(', ')}</div>
  );
  
};

FullAddressPreview.propTypes = {
  showCountry: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.object
};

FullAddressPreview.defaultProps = {};

export default memo(FullAddressPreview);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} address this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderFullAddressPreview = (address, entity) => {
  return (
    <FullAddressPreview entity={entity} value={address} showCountry/>
  );
};
